"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDate = exports.formatDateTimeShort = exports.parseDate = exports.EvenDateTimeFormat = exports.DateTimeFormat = exports.EvenDateFormat = exports.TimeFormat = exports.DateTimeLongFormat = exports.DateLongFormat = exports.DateFormat = void 0;
exports.formatDate = formatDate;
exports.formatTime = formatTime;
exports.formatDateAndTime = formatDateAndTime;
exports.addMonth = addMonth;
exports.dateRange = dateRange;
const tslib_1 = require("tslib");
const isDate_1 = tslib_1.__importDefault(require("lodash/isDate"));
const luxon_1 = require("luxon");
const moment_1 = tslib_1.__importDefault(require("moment"));
exports.DateFormat = 'MM/DD/YYYY';
exports.DateLongFormat = 'MMM DD, YYYY';
exports.DateTimeLongFormat = 'MMM DD, YYYY HH:ss A';
exports.TimeFormat = 'HH:mm:ss';
exports.EvenDateFormat = 'YYYY-MM-DD';
exports.DateTimeFormat = `${exports.DateFormat} ${exports.TimeFormat}`;
exports.EvenDateTimeFormat = `${exports.EvenDateFormat} ${exports.TimeFormat}`;
const parseDate = (date) => {
    if (luxon_1.DateTime.isDateTime(date)) {
        return date;
    }
    if ((0, isDate_1.default)(date)) {
        return luxon_1.DateTime.fromJSDate(date);
    }
    return luxon_1.DateTime.fromISO(date);
};
exports.parseDate = parseDate;
function formatDate(value, format) {
    return (0, moment_1.default)(value).format(format || 'MM/DD/YYYY');
}
function formatTime(value) {
    return (0, moment_1.default)(value).format('HH:mm:ss');
}
function formatDateAndTime(value) {
    return `${formatDate(value)} ${formatTime(value)}`;
}
const formatDateTimeShort = (date) => {
    return (0, exports.parseDate)(date).toLocaleString(luxon_1.DateTime.DATETIME_SHORT);
};
exports.formatDateTimeShort = formatDateTimeShort;
function addMonth(value, month) {
    return (0, moment_1.default)(value).add(month, 'M').format('MM/DD/YYYY');
}
const toDate = (date) => {
    if (typeof date === 'string') {
        return new Date(date.replace(/-/g, '/'));
    }
    if (typeof date === 'number') {
        return new Date(date);
    }
    return date;
};
exports.toDate = toDate;
function dateRange(startDate, endDate) {
    const sDate = (0, exports.toDate)(startDate);
    const eDate = (0, exports.toDate)(endDate);
    const isSameMonth = sDate.getMonth() === eDate.getMonth();
    const isSameYear = sDate.getFullYear() === eDate.getFullYear();
    const startDateFormat = `MMM DD${!isSameYear ? ', YYYY ' : ''}`;
    const endDateFormat = `${!isSameMonth || !isSameYear ? 'MMM ' : ''}DD, YYYY`;
    return `${(0, moment_1.default)(sDate).format(startDateFormat)} - ${(0, moment_1.default)(eDate).format(endDateFormat)}`;
}
